<template>
  <div>
    <div class="stop-watch-kind-list">
      <button value="basic" class="stop-watch-kind-item" :class="{active: selectedStopwatchType === 'basic'}" @click="onChangeKind">{{ $t('camstudy.stopwatch.type.basic') }}</button>
      <button value="cash-item-01" class="stop-watch-kind-item" :class="{active: selectedStopwatchType === 'cash-item-01'}" @click="onChangeKind">{{ $t('camstudy.stopwatch.type.six') }}</button>
<!--      <button v-if="!isDevicetest" class="save-button" @click="onSaveStopWatch"></button>-->
    </div>
    <div v-if="selectedStopwatchType === 'basic'" class="stop-watch-item-list">
      <div v-for="item in basicStopWatchList" :key="item.id" class="stop-watch-item" :class="{active: selectedStopwatchSubType.id === item.id}" @click="() => onChangeStopWatch(item)">
        <div class="stop-watch-time-basic" :style="{fontStyle: item.font, background: item.background}">00:00:00</div>
      </div>
    </div>
    <div v-else-if="selectedStopwatchType === 'cash-item-01'" class="stop-watch-item-list" :class="{'device-coordi': isDevicetest}">
      <div v-for="item in cashItemList" :key="item.id" class="stop-watch-item" :class="{active: selectedStopwatchSubType.id === item.id}" @click="() => onChangeStopWatch(item)">
        <img class="stop-watch-background-image" :src="getImageUrl(item.background)" alt="background" />
        <div class="stop-watch-time-basic">00:00:00</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'StopWatch',
  props: {
    isDevicetest: {
      type: Boolean,
      default: false
    },
    roomInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data(){
    return {
      basicStopWatchList: [{id: 'default', background: 'rgba(0, 0, 0, 0.7)', font: 'basic'}, {id: 'color-italic', background: 'rgba(0, 90, 180, 0.70)', font: 'italic'}],
      cashItemList: [{id: '1', background: 'image1'},{id: '2', background: 'image2'},{id: '3', background: 'image3'},{id: '4', background: 'image4'},{id: '5', background: 'image5'},{id: '6', background: 'image6'}],
      selectedStopwatchType: '',
      selectedStopwatchSubType: {},
    }
  },
  async created() {
    const userProfile = await this.getCamStudyUserProfile({ roomId: this.roomInfo?.roomId || this.camStudy.roomId });
    await this.getCamStudyUserStopWatchSetting({
      roomId: this.roomInfo?.roomId || this.camStudy.roomId,
      userId: userProfile.userId
    });

    let userStopWatchSetting;
    if(this.isDevicetest) {
      userStopWatchSetting = this.getStopWatchSetting?.userItemSetting;
    } else {
      const camStudyUser = await this.getCamStudyUser(this.me.userId);
      userStopWatchSetting = camStudyUser?.camStudyUserItemSettingList?.[0]?.itemSetting;
    }

    this.selectedStopwatchType = userStopWatchSetting?.selectedStopwatchType || 'basic';
    this.selectedStopwatchSubType = this.getStopWatchSubType(userStopWatchSetting?.selectedStopwatchSubType) || this.basicStopWatchList[0];

    this.onChangeStopWatchImage()
  },
  computed:{
    ...mapGetters('camstudy', [
        'getStopWatchSetting',
        'getCamStudyUser',
        'camStudy',
    ]),
    ...mapGetters('user', [
        'me'
    ]),
    ...mapGetters('room',[
      'isPremiumRoom'
    ]),
    getImageUrl(){
      return (background) => {
        return require(`@/assets/images/camstudy/stopwatch_background_${background}.svg`);
      }
    }
  },
  methods:{
    ...mapActions('camstudy', [
      'getCamStudyUserProfile',
      'getCamStudyUserStopWatchSetting',
    ]),
    getStopWatchSubType(subType) {
      if(this.selectedStopwatchType === 'basic') {
        return this.basicStopWatchList.find((v) => v.id === subType);
      } else if(this.selectedStopwatchType === 'cash-item-01') {
        return this.cashItemList.find((v) => v.id === subType);
      }

      return this.basicStopWatchList[0];
    },
    onChangeKind(e){
      // const currentStopWatchType = e.target.value;
      // if(currentStopWatchType === 'cash-item-01') {
      //   const userItemList = this.getStopWatchSetting?.userItemList;
      //   const hasItem = userItemList?.filter(({name})  => name === this.$t('camstudy.stopwatch.name'))
      //   if(!hasItem) {
      //     this.orderStopWatchItem({text: this.$t('camstudy.stopwatch.type.six')});
      //     return;
      //   }
      // }

      if(e.target.value === 'cash-item-01') {
        const STOP_WATCH_CASH = '72z6yze5p6ozz'

        const findCash = this.getStopWatchSetting?.userItemList.find((v) => v.id === STOP_WATCH_CASH)
        if(!findCash){
          this.$camsAlert({
            title: this.$t('camstudy.stopwatch.noItem'),
            text: this.$t('camstudy.stopwatch.shopText'),
            okText: this.$t('camstudy.stopwatch.move'),
            ok: () => {
              const env = process.env.NODE_ENV;
              if(env === 'development') {
                window.open('https://cams-dev.gooroomee.com/camstudy/shop', '_blank');
              }else if(env === 'production') {
                window.open('https://gooroomee.com/camstudy/shop', '_blank');
              }
            }
          })
          return;
        }
      }
      this.selectedStopwatchType = e.target.value
    },
    onChangeStopWatch(value){
      this.selectedStopwatchSubType = value
      this.onChangeStopWatchImage()
    },
    onChangeStopWatchImage() {
      const stopwatchInfo = {
        type: this.selectedStopwatchType,
        subType: this.selectedStopwatchSubType.id
      }

      this.$emit('onChangeStopWatchImage', stopwatchInfo);
    },
    onSaveStopWatch(){
      const stopwatchInfo = {
        type: this.selectedStopwatchType,
        subType: this.selectedStopwatchSubType.id
      }

      this.$emit('saveCoordi', 'stopwatch');
    },
    orderStopWatchItem(stopwatchItem) {
      this.$camsAlert({
        title: stopwatchItem.text + ' ' + this.$t('camstudy.stopwatch.noItem'),
        text: this.$t('camstudy.stopwatch.shopText'),
        okText: this.$t('camstudy.stopwatch.move'),
        ok: () => {

        },
      })
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .stop-watch-item-list{
    @media(orientation: portrait) {
      height: calc(100dvh - 64px - 100dvw - 80px);
      padding-bottom: 10px;
      &.device-coordi{
        height: calc(100dvh - 100px - 100vw - 100px);
      }
    }
    @media(orientation: landscape) {
      height: calc(100dvh - 184px);
      &.device-coordi{
        height: calc(100dvh - 234px);
      }
    }
  }
}
html:not([grm-device-mobile]){
  .stop-watch-item-list{
    max-height: 278px;
    height: 100%;
    &::-webkit-scrollbar{
      display: none;
    }
  }
}
.stop-watch-kind-list{
  position: relative;
  display: flex;
  gap: 16px;
  padding: 0 10px;
  // margin-bottom: 10px;

  .stop-watch-kind-item{
    height: 36px;
    font-size: 14px;
    line-height: 150%;
    color: white;
    display: flex;
    align-items: center;

    &.active{
      color: #2A8BFE;
      font-weight: 700;
      border-bottom: 2px solid #2A8BFE;
    }
  }
  .save-button{
    position: absolute;
    right: 10px;
    top: 0;
    width: 32px;
    height: 32px;
    background: url("~@/assets/images/camstudy/ico_saveSticker_white.svg") no-repeat center center;
  }
}

.stop-watch-item-list{
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 0;
  overflow-y: scroll;
  
  .stop-watch-item{
    width: calc(50% - 5px);
    height: 72px;
    padding: 0;
    border-radius: 6px;
    background: #393939;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    &.active{
      &::after{
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 6px;
        border: 4px solid #016FF2;
        background: rgba(1, 111, 242, 0.50) url("~@/assets/images/camstudy/ico_check_white.svg") no-repeat center center;
        background-size: 24px auto;
      }
    }
    .stop-watch-time-basic{
      color: #FFF;
      font-size: 16px;
      font-weight: 700;
      width: 126px;
      height: 36px;
      padding: 6px 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
    }
    .stop-watch-time-basic{
      color: #FFF;
      font-size: 16px;
      font-weight: 700;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .stop-watch-background-image{
      width: 126px;
      height: 36px;
    }
  }
}
</style>